export const termsData = [
  {
    id: 1,
    title: "1. Acceptance of Terms",
    subtitle:
      "By accessing or using our website, registering for a program, or participating in any activity related to Outlast Football Club, you agree to comply with these Terms & Conditions.",
  },
  {
    id: 2,
    title: "2. Registration and Participation",
    subtitle:
      "All participants must complete registration and submit accurate personal details",
    subtitle_2: "Fees are to be paid in full before the program start date.",
    subtitle_3:
      "Outlast Football Club reserves the right to reject or cancel registrations at its discretion.",
  },
  {
    id: 3,
    title: "3. Code of Conduct",
    subtitle:
      "All players must show respect towards coaches, fellow players, referees, and staff.",
    subtitle_2:
      "Violent behavior, bullying, or misuse of equipment will result in suspension or dismissal.",
  },
  {
    id: 4,
    title: "4. Cancellations & Refunds",
    subtitle:
      "Fees are non-refundable unless the academy cancels a program.",
      subtitle_2 : "Any requests for refunds due to medical or personal reasons will be reviewed case-by-case."
  },
  {
    id: 5,
    title: "5. Photography & Media",
    subtitle:
      "We may take photos and videos during training and events to promote the academy on social media, our website, and marketing materials.",
      subtitle_2 : "If you do not wish your child to appear, please inform us in writing."
  },
  {
    id: 6,
    title: "6. Liability",
    subtitle:
      "While we take atmost care in ensuring safety, Outlast Football Club is not liable for injuries or loss of personal belongings during sessions.",
  },
    {
    id: 7,
    title: "7. Changes to Programs",
    subtitle:
      "We reserve the right to change schedules, locations, or coaching staff as needed. Any major changes will be communicated in advance.",
  },
];
